/** The boxes `table-cell.component.scss` gives an ellipsis. */
const CLIPPED_BOXES = 'span, div, p, a';

/** Kit parts whose glyphs spill out of their box on purpose (also excluded in the SCSS). */
const OWN_OVERFLOW = 'fr8bot-ui-icon, fr8bot-ui-avatar, fr8bot-ui-image, fr8bot-ui-loading';

function overflows(element: Element): boolean {
  return element.scrollWidth > element.clientWidth;
}

/** Whether any text in a table cell ends in "…". Reads layout: call it from an observer callback. */
export function isTruncated(container: HTMLElement): boolean {
  if (overflows(container)) {
    return true;
  }

  return Array.from(container.querySelectorAll(CLIPPED_BOXES)).some(
    (box) => !box.closest(OWN_OVERFLOW) && overflows(box),
  );
}

/**
 * A cell's text on one line, as the tooltip shows it: stacked date and time read as one. Icon-font
 * glyphs are text nodes too (`fr8bot-ui-icon`), so kit parts are left out.
 */
export function cellText(container: HTMLElement): string {
  const walker = container.ownerDocument.createTreeWalker(container, NodeFilter.SHOW_TEXT);
  const parts: string[] = [];

  for (let node = walker.nextNode(); node; node = walker.nextNode()) {
    if (!node.parentElement?.closest(OWN_OVERFLOW)) {
      parts.push(node.textContent ?? '');
    }
  }

  return parts.join(' ').replace(/\s+/g, ' ').trim();
}
